import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';
import { BsDropdownModule } from 'ngx-bootstrap';
import { UsRegisterHospitalsComponent } from './us-register-hospitals.component';
import { UsRegisterHospitalsRouting } from './us-register-hospitals-routing.module';
import { UsRegisterHospitalsService } from './us-register-hospitals.services';

@NgModule({
  declarations: [UsRegisterHospitalsComponent],
  imports: [CommonModule, SharedModule, UsRegisterHospitalsRouting, BsDropdownModule.forRoot()],
  providers: [UsRegisterHospitalsService]
})
export class UsRegisterHospitalsModule {}



// WEBPACK FOOTER //
// ./src/app/t2-us-register-hospitals/us-register-hospitals.module.ts